module.exports = __webpack_public_path__ + "static/img/tutorial2_1.191f010.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_dealer/tutorial2_1.png
// module id = 1Qb4
// module chunks = 0